import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GetSingleUserModel, useAppSelector, UserRole } from "@shared/ui";

import { userService, droneService, Header, DroneList } from "@shared/ui";
import { GetShortDroneModel } from "@shared/ui";

const UserPage: React.FC = () => {
  const { t } = useTranslation();
  const { userId } = useParams();
  const [user, setUser] = useState<GetSingleUserModel | null>(null);
  const [isAddDrone, setAddDrone] = useState(false);
  const currUser = useAppSelector((store) => store.user.value);
  const customer = useAppSelector((store) => store.customer.value);
  const [unassignedDrones, setUnassignedDrones] = useState<
    GetShortDroneModel[]
  >([]);
  const [allDrones, setAllDrones] = useState<GetShortDroneModel[]>([]);
  const [currentPageDrones, setCurrentPageDrones] = useState<number>(1);
  const pageSize = 10;
  const [totalPagesDrones, setTotalPagesDrones] = useState(1);

  useEffect(() => {
    if (customer) {
      droneService
        .getDrones(customer.id, currentPageDrones, pageSize)
        .then((data) => {
          setAllDrones(data.items);
          setTotalPagesDrones(data.totalPageCount);
        })
        .catch();
    }
  }, [customer]);

  useEffect(() => {
    if (user?.drones) {
      const assigned = user.drones.map((d) => d.id);
      setUnassignedDrones(allDrones.filter((u) => !assigned.includes(u.id)));
    } else {
      setUnassignedDrones(allDrones);
    }
  }, [user]);

  useEffect(() => {
    if (userId) {
      userService
        .getUser(+userId)
        .then((data) => {
          setUser(data);
        })
        .catch();
    }
  }, [userId]);

  const closeModal = () => {
    setAddDrone(false);
  };

  const assignDrone = (droneId: string) => {
    if (user) {
      userService
        .assignUserDrone(user.id, droneId)
        .then((data) => {
          setUser(data);
        })
        .catch();
    }
  };

  const unAssignDrone = (droneId: string) => {
    if (user) {
      userService
        .unAssignUserDrone(user.id, droneId)
        .then((data) => {
          setUser(data);
        })
        .catch();
    }
  };

  const blockUser = async () => {
    try {
      if (user) {
        await userService.blockUser(user.id);
        setUser({ ...user, isBlocked: true });
      }
    } catch {}
  };

  const handlePageChangeDrones = (page: number) => {
    setCurrentPageDrones(page);
  };

  return (
    <div className="container">
      <Header />
      <NavLink className="btn btn-text text-left" to={"/dashboard/?tab=1"}>
        {t("userPage.backButton")}
      </NavLink>
      {user && (
        <div className="user-info-wrapper">
          <div className="user-info-header">
            <h1>
              {user.userName} {user.displayName}{" "}
              {user.isBlocked && <span className="blocked">{t("userPage.blockedLabel")}</span>}
            </h1>
            <div className="group-btn">
              {currUser?.role !== UserRole.Operator && (
                <button className="btn" onClick={() => setAddDrone(true)}>
                  {t("userPage.buttons.addDrone")}
                </button>
              )}
              {currUser?.role !== UserRole.Operator && !user.isBlocked && (
                <button className="btn btn-secondary" onClick={blockUser}>
                  {t("userPage.buttons.blockOperator")}
                </button>
              )}
            </div>
          </div>

          <ul className="drone-usage-info">
            {/*<li><strong>Логін:</strong>  </li>
                    <li><strong>Ім'я:</strong>  </li>*/}
            <li>
              <strong>{t("userPage.info.lastMissionDate")}</strong> {user.lastMissionDate}
            </li>
            <li>
              <strong>{t("userPage.info.totalMissionHours")}</strong>{" "}
              {user.totalMissionHours}
            </li>
          </ul>
        </div>
      )}

      {user && (
        <div>
          <h2>{t("userPage.dronesSection.title")}</h2>
          <DroneList
            dronesListData={user.drones}
            onDelete={unAssignDrone}
            showControls={true}
            totalPages={totalPagesDrones}
            currentPage={currentPageDrones}
            handlePageChangeDrones={handlePageChangeDrones}
          />
        </div>
      )}

      {isAddDrone && currUser?.role !== UserRole.Operator && (
        <div className="modal-wrapper">
          <dialog open onCancel={closeModal}>
            <div className="modal-header">
              <h4>{t("userPage.addDroneModal.title")}</h4>
              <button onClick={closeModal}>✕</button>
            </div>
            <DroneList
              dronesListData={unassignedDrones}
              onAdd={assignDrone}
              showControls={false}
              totalPages={totalPagesDrones}
              currentPage={currentPageDrones}
              handlePageChangeDrones={handlePageChangeDrones}
            />
            {/*<div className="text-center">
                            <button onClick={closeModal} className="btn btn-primary">
                                Закрити
                            </button>
                        </div>*/}
          </dialog>
        </div>
      )}
    </div>
  );
};
export default UserPage;
